export interface PasswordResetData {
  password: string;
  isResetLink: boolean;
  isAdmin: boolean;
  userId?: string;
  oldPassword?: string;
  currentUser?: string;
  token?: string;
}
